<template>
  <div class="page">

    <!-- <Nav activeIndex="1"></Nav> -->

    <div v-html="html" style="text-align: left;">

    </div>

  </div>
</template>

<script>
// import Nav from '@/components/Nav.vue'
export default {
  name: 'PageStateM',
  components: {
    // Nav
  },
  data () {
    return {
      html: '<p>사이트 이용 안내</p><p>안녕하세요. 저희 사이트는 업데이트 후 한 달 뒤에 콘텐츠가 삭제됩니다. 또한, 음악, 비디오, 멀티미디어 파일을 저장하지 않으며, 다른 웹사이트에서 링크된 콘텐츠이며 저작권, 적법성, 정확성, 규정 준수 등에 대해 책임을 지지 않습니다. 법적 문제 발생 시 해당 미디어 파일 소유자 또는 호스팅 업체에 직접 문의해 주시기 바랍니다.</p><p>감사합니다.</p>'
    }
  },
  methods: {

  }
}
</script>
<style>
  .subtitle{
    text-align: left;
    min-width: 150px;
  }
</style>
